import { mdiSync } from '@mdi/js';
import Icon from '@mdi/react';
import { observer } from 'mobx-react';
import React from 'react';
import { WorkerStore } from '../../../stores/worker-configuration/worker.store';
import * as S from '../configuration-page.styles';

interface IConfigurationCatalogBannerProps {
    store: WorkerStore;
}

export const ConfigurationCatalogBanner: React.FC<IConfigurationCatalogBannerProps> = observer(({ store }) => {
    if (!store.catalogImporting) {
        return null;
    }

    return (
        <S.CatalogBanner>
            <Icon path={mdiSync} size={0.75} color="#2E6BE6" aria-hidden={true} />
            <span>Loading code catalog…</span>
        </S.CatalogBanner>
    );
});
